define('TescoMobile_ClubCard/js/view/summary/item/details-mixin',['jquery'], function ($) {
  'use strict';

  return function (renderer) {
    return renderer.extend({
      initialize: function () {
        this._super();
        this.extensionTemplates.device.push('TescoMobile_ClubCard/summary/item/clubcard/device');
        this.extensionTemplates.tariff.push('TescoMobile_ClubCard/summary/item/clubcard/tariff');
        this.extensionTemplates.monthly.push('TescoMobile_ClubCard/summary/item/clubcard/monthly');
        this.extensionTemplates.today.push('TescoMobile_ClubCard/summary/item/clubcard/today');
        this.extensionTemplates.upfront.push('TescoMobile_ClubCard/summary/item/clubcard/aui');
      },
      oldPrice: function () {
        $('.opc-block-summary .product-item .clubcard.today-cost').prev().children('.value').addClass('old-price');
        $('.opc-block-summary .product-item .clubcard.monthly-cost').prev().children('.value').addClass('old-price');
        $('.opc-block-summary .product-item .clubcard.tariff').parent().children('.usage').children('.value').addClass('old-price');
        $('.opc-block-summary .product-item .clubcard.device').parent().children('.item:not(.inline):not(.upfront-cost)').children('.value').addClass('old-price');
        $('.opc-block-summary .product-item .clubcard.upfront-cost').parent().children('.item.upfront-cost').children('.value').addClass('old-price');
      }
    });
  };
});

